<template>
  <div>
    {{ item.projectName }} <br>
    <i>{{ item.product }}</i>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
